module.exports = __webpack_public_path__ + "static/optimisation-8aa99e1dd16ecf0c0123c6ff53caea1a.jpg";